// extracted by mini-css-extract-plugin
export default {"list":"feel-insecure_list__ajXsy","arrow_icon":"feel-insecure_arrow_icon__-4k9U","subtitle":"feel-insecure_subtitle__JUTzS"};